import React from 'react';
import { Center, Icon, CenterProps } from '@chakra-ui/react';
import { XIcon } from '@heroicons/react/solid';

interface ModalCloseButtonProps extends Omit<CenterProps, 'onClick'> {
  onClose: () => void;
  size?: string;
  iconSize?: string;
  // `left`/`top` come from CenterProps — don't redeclare them as `string`,
  // that narrows away Chakra's responsive object form.
}

export const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
  onClose,
  size = '48px',
  iconSize = '18px',
  left = '-60px',
  top = '32px',
  ...props
}) => {
  return (
    <Center
      w={size}
      h={size}
      left={left}
      top={top}
      pos="absolute"
      bg="base-white"
      border="1px solid"
      borderColor="border-color"
      boxShadow={'drop-shadows-outer-primary'}
      borderRadius="full"
      onClick={onClose}
      cursor="pointer"
      _hover={{
        bg: 'secondary-50',
      }}
      {...props}
    >
      <Icon
        data-test-id="close-candidate-job-application-details-icon"
        as={XIcon}
        cursor="pointer"
        w={iconSize}
        h={iconSize}
      />
    </Center>
  );
};

export default ModalCloseButton;
